import { Button } from "antd";
import React from "react";
import "./SecondaryButton.scss";

const SecondaryButton = ({
  label,
  icon,
  htmlType,
  loading,
  style,
  color,
  className,
  onClick,
  size,
  // GF-63: `disabled` was missing here while PrimaryButton had it. A caller
  // passing disabled got NO error and NO effect — the prop was dropped on the
  // floor and the button stayed clickable, which is how half of GF-63's fix
  // would have been silently inert.
  //
  // Adding it is additive because the prop is only forwarded to antd's Button:
  // a caller that omits it passes undefined, exactly as before. (There is one
  // live call site today — ConfirmAddress, which does pass it. The occurrence
  // in Pages/Zones.jsx is commented-out dead code.)
  //
  // Do not remove this as an unused prop: tools/confirm-address/confirm-unit-test.js
  // FAILS if it stops being destructured or stops reaching Button.
  disabled,
}) => {
  return (
    <Button
      type="secondary"
      className={`btn-secondary ${color} ${className} ${size}`}
      htmlType={htmlType}
      loading={loading}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
      {icon}
    </Button>
  );
};

export default SecondaryButton;
